/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 176:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(177);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _qty_selector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(178);


var selectors = {
  variantSelector: '[data-product-select]',
  decrementQtyBtn: '[data-decrement-qty]',
  incrementQtyBtn: '[data-increment-qty]',
  qtyInput: '[data-qty-input]',
  addButton: '.product-card__add',
  addedLabel: '.product-card__added',
  noSide: '.no-side-cart'
};
var cssClasses = {
  show: 'show'
};

function ProductCard(container) {
  var _variantSelector$opti;

  var variantSelector = container.querySelector(selectors.variantSelector);
  var qtyInput = container.querySelector(selectors.qtyInput);
  if (!variantSelector || !qtyInput) return;
  var selectedVariantId = (_variantSelector$opti = variantSelector.options[variantSelector.selectedIndex]) === null || _variantSelector$opti === void 0 ? void 0 : _variantSelector$opti.value;
  (0,_qty_selector__WEBPACK_IMPORTED_MODULE_1__.default)(container.querySelector(selectors.decrementQtyBtn), container.querySelector(selectors.incrementQtyBtn), container.querySelector(selectors.qtyInput));
  container.addEventListener('click', function (evt) {
    var _window$sideCart;

    var target = evt.target;
    var addButton = target.closest(selectors.addButton);
    if (!addButton || addButton.disabled) return;
    evt.preventDefault();
    var addedLabel = container.querySelector(selectors.addedLabel);
    var noSideCart = container.querySelector(selectors.noSide);
    var item = {
      id: selectedVariantId,
      quantity: qtyInput.value
    };
    (_window$sideCart = window.sideCart) === null || _window$sideCart === void 0 ? void 0 : _window$sideCart.handleAddToCartEvent(item, !noSideCart);
    addedLabel === null || addedLabel === void 0 ? void 0 : addedLabel.classList.add(cssClasses.show);
    setTimeout(function () {
      addedLabel === null || addedLabel === void 0 ? void 0 : addedLabel.classList.remove(cssClasses.show);
    }, 2000);
  });
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductCard);

/***/ }),

/***/ 178:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(179);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);


var qtySelector = function qtySelector(decrementBtn, incrementBtn, input) {
  if (!decrementBtn || !incrementBtn || !input) return;
  var inputMin = Number(input.getAttribute('min'));
  decrementBtn.addEventListener('click', function () {
    var newQty = Number(input.value) - 1;

    if (newQty <= 0) {
      return;
    }

    input.value = Number(newQty);
    input.dispatchEvent(new Event('change'));

    if (newQty <= inputMin) {
      decrementBtn.setAttribute('disabled', '');
    }
  });
  incrementBtn.addEventListener('click', function () {
    var newQty = Number(input.value) + 1;
    input.value = Number(newQty);
    input.dispatchEvent(new Event('change'));

    if (newQty > inputMin) {
      decrementBtn.removeAttribute('disabled');
    }
  });
  input.addEventListener('input', function () {
    if (input.value <= inputMin) {
      decrementBtn.setAttribute('disabled', '');
    } else {
      decrementBtn.removeAttribute('disabled');
    }
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (qtySelector);

/***/ }),

/***/ 199:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(132);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(135);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);
/* harmony import */ var _components_product_card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(176);
var _window$Shopify, _window$Shopify$theme, _window$Shopify$theme2;





var selectors = {
  productCard: '.product-card',
  content: '.article__main-content',
  readMore: '[js-read="read-more"]',
  mainCopy: '[js-read="copy"]'
};
var registeredSections = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : (_window$Shopify$theme = _window$Shopify.theme) === null || _window$Shopify$theme === void 0 ? void 0 : (_window$Shopify$theme2 = _window$Shopify$theme.sections) === null || _window$Shopify$theme2 === void 0 ? void 0 : _window$Shopify$theme2.registered) || {};
var isUnregistered = typeof registeredSections[sectionType] === 'undefined';
var sectionType = 'main-article';
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isUnregistered && (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__.register)(sectionType, {
  onLoad: function onLoad() {
    var container = this.container;
    var readMore = this.container.querySelectorAll(selectors.readMore);

    if (readMore) {
      readMore.forEach(function (ret) {
        var copy = ret.previousElementSibling;
        var copyChild = copy.firstElementChild;

        if (copyChild.scrollHeight < copy.clientHeight) {
          ret.style.display = 'none';
        }

        ret.addEventListener('click', function (evt) {
          evt.preventDefault();
          copy.classList.toggle('is-active');

          if (ret.innerHTML === theme.strings.producers.readMore) {
            ret.innerHTML = theme.strings.producers.readLess;
            return;
          }

          ret.innerHTML = theme.strings.producers.readMore;
        });
      });
    }

    var productCards = container.querySelectorAll(selectors.productCard);
    productCards.forEach(function (product) {
      return (0,_components_product_card__WEBPACK_IMPORTED_MODULE_3__.default)(product);
    });
    var contentContainer = this.container.querySelector(selectors.content);
    var images = contentContainer.querySelectorAll('img');
    images.forEach(function (image) {
      var realHeight = image.naturalHeight;
      var floatStyle = image.style["float"];
      var marginBottomStyle = image.style.marginBottom;
      image.style.marginBottom = 0;
      var marginLeftStyle = image.style.marginLeft;
      image.style.marginLeft = 0;
      var marginRightStyle = image.style.marginRight;
      image.style.marginRight = 0;
      var marginTopStyle = image.style.marginTop;
      image.style.marginTop = 0;

      if (floatStyle) {
        image.parentElement.style["float"] = floatStyle;

        if (floatStyle == 'none') {
          image.style.maxHeight = "".concat(realHeight, "px");
          image.style.objectFit = 'none';
        }
      }

      if (marginBottomStyle) {
        image.parentElement.style.marginBottom = marginBottomStyle;
      }

      if (marginTopStyle) {
        image.parentElement.style.marginTop = marginTopStyle;
      }

      if (marginLeftStyle) {
        image.parentElement.style.marginLeft = marginLeftStyle;
      }

      if (marginRightStyle) {
        image.parentElement.style.marginRight = marginRightStyle;
      }
    });
  }
}));

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			16: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkbibendum"] = self["webpackChunkbibendum"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [37], () => (__webpack_require__(199)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;